import { calcSensorHex } from '@helpers/helper';

import type { IEquipment } from '@model/equipment';
import type { IInstallationPoint } from '@model/installationPoint';

export const getDetailsData = (
  t: (text: string) => string,
  point?: IInstallationPoint,
  equipment?: IEquipment,
) => {
  if (!point) return [];
  const pointSensor = point?.sensor;
  const hardwareType = pointSensor?.hardwareType;
  const locationInfo = equipment?.location;

  if (hardwareType === 'mote' || point?.point_type === 'boolean') {
    return [
      `${t('Installation Point Name')}: ${point?.name || '-'} (id: ${point.id})`,
      `${t('Hex Code')}: ${calcSensorHex(pointSensor?.hardwareId, point?.sensorId)}`,
      `${t('Location')}: ${locationInfo?.name || '-'} (location_id: ${locationInfo?.id || '-'})`,
      `${t('Equipment')}: ${equipment?.name || '-'} (equipment_id: ${equipment?.id || '-'})`,
      `${t('Facility Name')}: ${locationInfo?.facilityName || '-'} (facility_id: ${
        locationInfo?.facilityId || '-'
      })`,
      `${t('Asset Code')}: ${equipment?.assetCode || '-'}`,
    ];
  }

  if (hardwareType === 'sensor') {
    return [
      `${t('Installation Point Name')}: ${point?.name || '-'}  (id: ${point.id})`,
      `${t('Hex Code')}: ${calcSensorHex(pointSensor?.hardwareId, point?.sensorId)}`,
      `${t('Location')}: ${equipment?.location?.name || '-'} (location_id: ${
        equipment?.location?.id || '-'
      })`,
      `${t('Equipment')}: ${equipment?.name || '-'} (equipment_id: ${equipment?.id || '-'})`,
      `${t('Facility Name')}: ${locationInfo?.facilityName || '-'} (facility_id: ${
        locationInfo?.facilityId || '-'
      })`,
      `${t('Node Serial Number')}: ${pointSensor?.node?.serial || '-'}`,
      `${t('Asset Code')}: ${equipment?.assetCode || '-'}`,
    ];
  }

  return [];
};
